import { MD5 } from 'crypto-js';

export function generateGravatarUrl(email: string): string {
  const emailHash = MD5(email);
  return 'https://www.gravatar.com/avatar/' + emailHash + '?d=identicon&s=200';
}
